import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import BackButton from '../../components/Messenger/Navigation/BackButton'
import MaximizeToggleButton from '../../components/Messenger/Navigation/MaximizeToggleButton'
import styled, { css } from 'styled-components'
import Navigation from '../../components/Messenger/Navigation'
import TopNavigation from '../../components/Messenger/TopNavigation'
import CloseButton from '../../components/Messenger/Navigation/CloseButton'
import { News, NewsCenter, NewsCenterMessengerEvent, NewsCenterMessengerEventType, PublicLocale, WidgetMessengerEventType } from '../../../types'
import Container from '../../components/Messenger/Container'
import { MessageHelper, WidgetHelper } from '../../helpers'
import NewsCenterHelper from '../../../helpers/NewsCenterHelper'
import ArticleSkeleton from '../../../help_center/components/Skeleton/ArticleSkeleton'
import { AppState } from '../../store'
import { connect } from 'react-redux'
import { NewsCenterController } from '../../controllers'
import ScrollToTopOnMount from '../../effects/ScrollToTopOnMount'

const Wrapper = styled.div<{ scrolled?: boolean, iframeLoaded?: boolean }>`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  flex: 1;
  flex-grow: 1;

  ${props => props.scrolled && css`
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  `}

  iframe {
    border: none;
    width: 100%;
    height: 100%;
    flex: 1;
    display: none;
    z-index: 999;

    ${props => props.iframeLoaded && css`
      display: block;
    `}
  }
`

type IProps = {
  locale: PublicLocale
  mobile: boolean
} & RouteComponentProps<{ id: string }>
interface IState {
  scrolled: boolean
  newsCenter: NewsCenter
  news: News
  didInitialLoad: boolean
  iframeLoaded: boolean
}

class NewsItem extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    this.state = {
      scrolled: false,
      newsCenter: null,
      news: null,
      didInitialLoad: false,
      iframeLoaded: false,
    }

    this.fetchNews = this.fetchNews.bind(this)
    this.onMessageReceive = this.onMessageReceive.bind(this)
  }

  componentDidMount(): void {
    window.addEventListener('message', this.onMessageReceive)
    MessageHelper.sendMessage({ type: WidgetMessengerEventType.MAXIMIZE_WINDOW })
    this.fetchNews()
  }

  componentWillUnmount(): void {
    window.removeEventListener('message', this.onMessageReceive)
    MessageHelper.sendMessage({ type: WidgetMessengerEventType.MINIMIZE_WINDOW })
  }

  async fetchNews() {
    const { match: { params: { id } } } = this.props
    try {
      this.setState({ didInitialLoad: false, iframeLoaded: false })
      const { news_center, news } = await NewsCenterController.getNewsItem(id)

      this.setState({
        newsCenter: news_center,
        news: news,
        didInitialLoad: true,
      })
    } catch (ex) {
      console.error(ex)
    }
  }

  onMessageReceive(event: MessageEvent<NewsCenterMessengerEvent>) {
    console.log('Received message:', event.data);
    if (!event?.data?.type) return
    const { history } = this.props

    switch (event.data.type) {
      case NewsCenterMessengerEventType.DEEP_LINK:
        history.push(WidgetHelper.deepLink(event.data.url))
        break
      case NewsCenterMessengerEventType.NEWS_LOADED:
        setTimeout(() => this.setState({ iframeLoaded: true }), 250)
        break
    }
  }

  render() {
    const { locale, mobile } = this.props
    const { scrolled, newsCenter, news, didInitialLoad, iframeLoaded } = this.state

    return (
      <Container>
        <ScrollToTopOnMount />
        <Navigation
          left={<BackButton />}
          title='News'
          right={<>
            {!mobile && <MaximizeToggleButton />}
            <CloseButton />
          </>}
          themed={false}
        />

        <TopNavigation />

        <Wrapper scrolled={scrolled} iframeLoaded={iframeLoaded}>
          {!iframeLoaded && <ArticleSkeleton margins />}
          {didInitialLoad && <iframe
            key={news.id}
            src={NewsCenterHelper.getNewsUrl(newsCenter, news, locale, { embed: true })}
          />}
        </Wrapper>
      </Container >
    )
  }
}

const mapStatetoProps = (state: AppState) => ({
  locale: state.application.locale,
  mobile: state.application.hostMobile,
})

export default connect(mapStatetoProps, null)(NewsItem)